/**
 * @file OrderRowChips.tsx
 * @description Стикеры строки заказа в реестре, на канбане и в мобильном
 * списке доски (phase19.24 §14, дефект QA 2026-09-21).
 *
 * Правило «не больше двух стикеров» живёт здесь, а не в трёх карточках: до
 * этого уголок карточки показывал владельца, а проблему не показывал вовсе —
 * менеджер видел «Склад» у заказа, который стоит из-за недостачи.
 *
 * Порядок тот же, что в полосе «Сейчас»: красный стикер проблемы первым,
 * владелец хода за ним и контуром (чтобы рядом с красным не кричать тем же
 * цветом). Нет ни проблемы, ни владельца — компонент ничего не рисует.
 */

import { OwnerChip } from "./OwnerChip";
import type { OrderDto } from "../../lib/api-orders";
import { ORDER_CHAIN_PROBLEM_LABEL } from "../../lib/order-chain-owner";

interface Props {
  order: OrderDto;
  /** Короткие подписи («вы», «решение») — для узких карточек канбана. */
  short?: boolean;
  className?: string;
}

export function OrderRowChips({ order, short = false, className }: Props) {
  const problem = order.problemNow ?? null;
  const owner = order.ownerNow ?? null;
  if (!problem && !owner) return null;

  // `span`, а не `div`: мобильный список доски рисует строку кнопкой, и блок
  // внутри `<button>` — невалидная разметка.
  return (
    <span className={className ?? "inline-flex flex-wrap items-center gap-1"}>
      {problem ? (
        <OwnerChip
          alert="PROBLEM"
          short={short}
          // Что именно случилось — в подсказке: в строке места на фразу нет.
          title={ORDER_CHAIN_PROBLEM_LABEL[problem]}
        />
      ) : null}
      {owner ? <OwnerChip owner={owner} short={short} outlined={!!problem} /> : null}
    </span>
  );
}
